/**
  * @file ad-dim.js
  * @brief 广告创建维度表 各种下拉列表的数据
  * @date 2019-06-18
  */

import DimCache from 'components/dim-cache/cache.js';
import { AD_PLAN_MAP, CAMPAIGN_DELIVERY } from './consts.js';

//维度表
const DIM = {}

export const Plan = {
  getCampaignTypes : (opts) => {
    if (!DIM.planType) {
      DIM.planType = new DimCache({
        url : '/v4/emi/authority/getCampaignTypes'
      });
    }    
    return  DIM.planType.getData(opts).then(data => {
      data.forEach(it => {
        it.key = +it.key;
      });
      return data.sort((a, b) => a.key - b.key);
    });
  },
  getDeliverPolicy : () => {
    return Promise.resolve([{name : '匀速投放', value : CAMPAIGN_DELIVERY.UNIFORM }, {name : '加速投放', value : CAMPAIGN_DELIVERY.ACCELERATE }]);
  },
  getDisplayType : (opts) => {
  
  }

  
}

export const Group = {

}
